<script lang="ts" setup>

defineProps({
  text: String,

})

</script>

<template>
    <div :class="{
      'cms-feature': true,
    }" v-html="text"></div>
</template>